import { useMutation } from '@tanstack/react-query';

import cycleMilestoneService, {
    type CycleMilestoneCreatePayload,
    type CycleMilestoneUpdatePayload,
} from './cycleMilestoneService';

import type { CycleMilestone } from '@/types/cycle-evaluation/CycleMilestone';

import { queryClient } from '@/AppWithProviders';
import { CycleMilestoneQueryKey } from '@/constants/QueryKeys';

const invalidateCycleMilestones = () =>
    queryClient.invalidateQueries({ queryKey: [CycleMilestoneQueryKey.CYCLE_MILESTONE] });

export const useCreateCycleMilestone = () =>
    useMutation<CycleMilestone, Error, CycleMilestoneCreatePayload>({
        mutationFn: (payload) => cycleMilestoneService.createCycleMilestone(payload),
        onSuccess: invalidateCycleMilestones,
    });

export interface UpdateCycleMilestoneVariables {
    id: string;
    payload: CycleMilestoneUpdatePayload;
}

export const useUpdateCycleMilestone = () =>
    useMutation<CycleMilestone, Error, UpdateCycleMilestoneVariables>({
        mutationFn: ({ id, payload }) => cycleMilestoneService.updateCycleMilestone(id, payload),
        onSuccess: invalidateCycleMilestones,
    });
